<template>
  <div id="taskReport" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '10px', height: '100%' }">
      <el-row class="h-full">
        <el-col :span="8" class="h-full">
          <el-row>
            <el-input
              prefix-icon="el-icon-search"
              placeholder="搜索表名、实体中文名称"
              v-model="search.keyword"
              size="small"
              clearable
            ></el-input>
          </el-row>
          <el-row class="mt-10px" style="height: calc(100% - 42px)">
            <el-table
              v-loading="loading.table"
              ref="table"
              :data="filterTableList"
              height="100%"
              @row-click="changeTable"
              style="width: 100%"
              border
              stripe
              highlight-current-row
            >
              <el-table-column prop="tableName" label="表名"></el-table-column>
              <el-table-column prop="name" label="实体中文名称"></el-table-column>
              <el-table-column label="来源系统">
                <template slot-scope="scope">
                  <span>{{
                    _.get(
                      _.find(scope.row.dynamicColumnData, {
                        actualAttributeColumnName: '来源系统',
                      }),
                      'value'
                    )
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="来源数据表">
                <template slot-scope="scope">
                  <span>{{
                    _.get(
                      _.find(scope.row.dynamicColumnData, {
                        actualAttributeColumnName: '来源数据表',
                      }),
                      'value'
                    )
                  }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-col>
        <el-col :span="16" class="h-full overflow-auto pl-10px fz-14">
          <el-row class="mb-5px">
            <span class="font-bold">任务名称：</span>
            <span>{{ taskInfo.name }}</span>
            <el-button type="primary" size="small" @click="goDetail" class="float-right"
              >返回</el-button
            >
          </el-row>
          <el-row class="mb-5px">
            <span class="font-bold">运行时间：</span>
            <span>{{ taskInfo.lastRunTime }}</span>
          </el-row>
          <el-row class="mb-5px">
            <span class="font-bold">质检源：</span>
            <span>{{ taskInfo.dataSourceName }}</span>
          </el-row>
          <el-row class="mb-5px">
            <span class="font-bold">数据源模型：</span>
            <span>{{ taskInfo.standardName }}</span>
          </el-row>
          <el-row class="mb-5px">
            <span class="font-bold">任务最新修改人：</span>
            <span>{{ taskInfo.lastModifiedUserName }}</span>
          </el-row>
          <el-row style="height: 240px">
            <v-chart ref="echart" class="h-full" :options="pieOption"></v-chart>
          </el-row>
          <el-row>
            <el-select class="mb-10px" v-model="search.status" placeholder="请选择" size="small">
              <el-option
                v-for="item in statusList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <div class="float-right mr-10px">
              <el-button type="primary" size="small" @click="goDetail">查看</el-button>
              <el-button size="small" @click="exportExcel" :loading="loading.export"
                >导出</el-button
              >
            </div>
          </el-row>
          <el-collapse v-model="activeNames">
            <el-collapse-item
              v-for="(rule, index) in filterRuleList"
              :key="index"
              :name="`${index + 1}`"
            >
              <template slot="title">
                <el-row class="w-full">
                  <el-col :span="2">
                    <span>{{ rule.ruleName }}</span>
                  </el-col>
                  <el-col :span="8" :offset="14">
                    <el-col :span="8">
                      <span>不合规值：</span>
                      <span>{{ rule.problemCount }}</span>
                    </el-col>
                    <el-col :span="8">
                      <span>数据总量：</span>
                      <span>{{ rule.checkCount }}</span>
                    </el-col>
                    <el-col :span="8">
                      <span>状态：</span>
                      <span :style="{ color: rule.problemCount > 0 ? 'red' : 'green' }">{{
                        rule.problemCount > 0 ? '红色告警' : '正常'
                      }}</span>
                    </el-col>
                  </el-col>
                </el-row>
              </template>
              <div>规则描述：{{ rule.description }}</div>
              <div>字段：{{ _.join(rule.classAttributeNameList, '、') }}</div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import QualityTaskService from '@/services/QualityTaskService'

export default {
  name: 'taskReport',
  mixins: [],
  components: {},
  data() {
    return {
      loading: {
        table: false,
        export: false,
      },
      search: {
        keyword: '',
        status: 1,
      },
      statusList: [
        { id: 1, name: '所有状态' },
        { id: 2, name: '正常' },
        { id: 3, name: '红色告警' },
      ],
      activeNames: ['1'],
      taskInfo: {},
      currentLi: {},
      tableList: [],
      ruleList: [],
      colorList: [
        { name: '正常', color: '#00af83' },
        { name: '红色告警', color: '#ff5959' },
      ],
      pieOption: {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          top: '5%',
          right: '20',
          orient: 'vertical',
        },
        title: {
          text: '',
          left: 'center',
          top: '40%',
          textStyle: {
            color: '#333',
            fontSize: 30,
            align: 'center',
          },
        },
        graphic: {
          type: 'text',
          left: 'center',
          top: '55%',
          style: {
            text: '规则总数',
            textAlign: 'center',
            fill: '#333',
            fontSize: 16,
            fontWeight: 300,
          },
        },
        series: [
          {
            name: '数量',
            type: 'pie',
            radius: ['55%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'outside',
              fontSize: 16,
              color: '#666',
              formatter: '{d}%',
              textStyle: {
                fontWeight: 300,
                fontSize: 16,
              },
            },
            emphasis: {
              label: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            },
            data: [],
            // itemStyle: {
            //   normal: {
            //     color: (params) => {
            //       return _.get(_.find(this.colorList, { name: params.name }), 'color')
            //     },
            //   },
            // },
          },
        ],
      },
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
    // 任务id
    taskId() {
      return this.$route.query.taskId
    },
    // 任务运行id
    taskRunId() {
      return this.$route.query.taskRunId
    },
    // 规则列表过滤
    filterRuleList() {
      // 正常
      if (this.search.status === 2) {
        return _.filter(this.ruleList, (item) => {
          return !item.problemCount
        })
      }
      if (this.search.status === 3) {
        // 红色告警
        return _.filter(this.ruleList, (item) => {
          return item.problemCount
        })
      }
      return this.ruleList
    },
    // 所有表-过滤
    filterTableList() {
      if (this.search.keyword) {
        const keyword = _.toLower(this.search.keyword)
        return _.filter(this.tableList, (item) => {
          return (
            _.includes(_.toLower(item.tableName), keyword) ||
            _.includes(_.toLower(item.name), keyword)
          )
        })
      }
      return this.tableList
    },
  },
  watch: {
    filterRuleList: {
      deep: true,
      handler(newVal) {
        // 默认展开全部
        this.activeNames = _.map(newVal, (item, index) => {
          return (index + 1).toString()
        })
        // const sum = _.sumBy(newVal, (item) => {
        //   return item.checkCount
        // })
        // this.pieOption.title.text = sum
        // const problemNum = _.sumBy(newVal, 'problemCount')
        // this.pieOption.series[0].data = [
        //   { name: '正常', value: sum - problemNum >= 0 ? sum - problemNum : 0 },
        //   { name: '红色告警', value: problemNum },
        // ]
      },
    },
  },
  methods: {
    goDetail() {
      this.$router.push(
        `${this.basePath}/legacy-resource/data-quality-manage/quality-task-form?id=${this.taskInfo.id}`
      )
    },
    async exportExcel() {
      this.loading.export = true
      const res = await QualityTaskService.exportFieldInfoList({
        pageno: 1,
        pagesize: 999,
        taskRunId: this.taskRunId,
        classId: this.currentLi.id,
      })
      if (res && res.code === 0 && res.url) {
        window.open(`${currentEnv.VUE_APP_STANDARD_SERVER}/${res.url}`, '_blank')
      }
      this.loading.export = false
    },
    changeTable(row) {
      this.currentLi = row
      this.getPieData()
    },
    // 获取左侧表数据
    async getTableList() {
      this.loading.table = true
      const res = await QualityTaskService.getTaskAssociationTableList({
        taskId: this.taskId,
      })
      if (res && res.code === 0 && res.data) {
        this.tableList = res.data
        this.currentLi = res.data[0]
        this.$refs.table.setCurrentRow(this.currentLi)
        this.getPieData()
      }
      this.loading.table = false
    },
    // 获取任务详情
    async getTaskInfo() {
      const res = await QualityTaskService.detail({
        id: this.taskId,
      })
      if (res && res.code === 0 && res.data) {
        this.taskInfo = res.data
      }
    },
    // 获取图表数据
    async getPieData() {
      this.pieOption.series[0].data = []
      const res = await QualityTaskService.getQualityReport({
        dataQualityTaskId: this.taskId,
        taskRunId: this.taskRunId,
        classId: this.currentLi.id,
      })
      if (res && res.code === 0 && res.data) {
        this.ruleList = res.data
        this.pieOption.title.text = res.data ? res.data.length : 0
        // 重复的规则名称放在一起
        const list = _.map(res.data, (item) => {
          return {
            name: item.ruleName,
            value: 1,
          }
        })
        _.map(list, (item, index) => {
          _.map(list, (lItem, lIndex) => {
            if (item && lItem && item.name === lItem.name && index < lIndex) {
              list[index].value = list[index].value + 1
              list.splice(lIndex, 1)
            }
          })
        })
        this.pieOption.series[0].data = list
      }
    },
  },
  created() {
    this.getTableList()
    this.getTaskInfo()
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
}
</script>
<style lang="scss" scoped>

#taskReport {
  .task-li {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .active {
    color: #1890fa;
    font-weight: bold;
  }
  /deep/ .el-collapse-item__content {
    padding-bottom: 25px;
  }
}

</style>
